import { useEffect } from "react";

export const CONFIRMATION_SOUND_PATH = "/sounds/ZeffyPaymentSound.mp3";

let audioContext: AudioContext | null = null;
let audioBuffer: AudioBuffer | null = null;

export const preloadConfirmationSound = () => {
  if (audioContext) {
    return;
  }

  try {
    audioContext = new AudioContext();
  } catch {
    return;
  }

  fetch(CONFIRMATION_SOUND_PATH)
    .then((res) => res.arrayBuffer())
    .then((buf) => audioContext!.decodeAudioData(buf))
    .then((decoded) => {
      audioBuffer = decoded;
    })
    .catch(() => {});
};

const DEFAULT_DELAY_MS = 500;

export const playConfirmationSound = async () => {
  if (audioContext && audioBuffer) {
    if (audioContext.state === "suspended") {
      await audioContext.resume().catch(() => {});
    }
    const source = audioContext.createBufferSource();
    source.buffer = audioBuffer;
    const gain = audioContext.createGain();
    gain.gain.value = 0.2;
    source.connect(gain).connect(audioContext.destination);
    source.start(0);
    return;
  }

  const audio = new Audio(CONFIRMATION_SOUND_PATH);
  audio.volume = 0.5;
  await audio.play().catch(() => {});
};

export const useConfirmationSound = (isPlayedElsewhere?: () => boolean) => {
  useEffect(() => {
    if (isPlayedElsewhere?.()) {
      return;
    }

    const timeout = setTimeout(() => void playConfirmationSound(), DEFAULT_DELAY_MS);
    return () => clearTimeout(timeout);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- plays once per page view, whatever the caller re-renders
  }, []);
};
